export function getSimulationData(axiosPrivate, body){
  return axiosPrivate.post(`/input-output/simulation-data`,{...body})
}

export function runSimulation(axiosPrivate, body){
  return axiosPrivate.post(`/input-output/run-simulation`,{...body})
}